module.exports = __webpack_public_path__ + "img/yom-hatzmaut-2020.bd1f3006.jpeg";